/**
 * Centralised snake_case → camelCase response transformer.
 *
 * Applied once in apiSlice's custom baseQuery so every RTK Query endpoint
 * receives camelCase keys automatically — no per-endpoint mapping needed.
 */

function snakeToCamel(str: string): string {
    return str.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase())
}

/**
 * Recursively convert all object keys from snake_case to camelCase.
 * Arrays are traversed, primitives and null/undefined are returned as-is.
 */
export function deepSnakeToCamel<T>(obj: T): T {
    if (obj === null || obj === undefined || typeof obj !== 'object') {
        return obj
    }

    if (Array.isArray(obj)) {
        return obj.map(deepSnakeToCamel) as T
    }

    const result: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
        result[snakeToCamel(key)] = deepSnakeToCamel(value)
    }
    return result as T
}
